import React from 'react';

const Support: React.FC = () => {
  return (
    <div className="support-page">
      <h1>Support</h1>
      <div className="support-buttons">
        <a 
          href="https://docs.google.com/document/d/1-yVUPbPBw46RB_qk-yys84Ky5xSDpK32I2szoTZ0-fo/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className="support-button"
        >
          Privacy Policy
        </a>
        <a 
          href="https://docs.google.com/document/d/1bg_VF8Qd3ac3_Fmu57kM-NfJoI11LRXBjmrArWZmduM/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className="support-button"
        >
          Terms of Service
        </a>
        <a 
          href="mailto:ankith@closingtheory.com"
          className="support-button"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

export default Support; 